import { gql } from '@apollo/client'

export const STREAM_CHAT_MESSAGES = gql`
  subscription OnChatMessageReceived($conversationId: Uuid!) {
    onChatMessageReceived(conversationId: $conversationId) {
      messageId
      userId
      conversationId
      content
      timestamp
      type
      isStreaming
      caseId
      pillsMessages
      leftPanels {
        debtorName
        items {
          type
          status
        }
      }
    }
  }
`
